export const TableColumn = [
  { label: '渠道ID', value: 'channelId', type: 'text' },
  { label: '渠道名称', value: 'packageName', type: 'text' },
  { label: '包名', value: 'sdk', type: 'text' }
]
